document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-bm-scroll-to]');
  if (!trigger) return;
  const targetId = trigger.getAttribute('data-bm-scroll-to');
  const el = targetId && document.getElementById(targetId.replace('#', ''));
  if (!el) return;
  event.preventDefault();
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const top = el.getBoundingClientRect().top + window.scrollY - 60;
  window.scrollTo({ top, behavior });
});
